export enum ServerStatus {
    UNAVAILABLE = <any>"UNAVAILABLE",
    INITIALISING = <any>"INITIALISING",
    INITIALISED = <any>"INITIALISED",
    FAILED = <any>"FAILED"
}

/**
 * Status of the BI server
 */
export class ServerStatusData {

    /**
     * Status
     * UNAVAILABLE
     * INITIALISING
     * INITIALISED
     * FAILED
     */
    status: ServerStatus;

    /**
     * Percentage complete in initialising
     */
    percentComplete: number = 0;
}
